import React from 'react'
import {makeStyles,Container,Typography} from "@material-ui/core"
import Carousel from './Carousel';

const useStyles = makeStyles(()=> ({
    banner : {
        backgroundImage : "url(https://i.imgur.com/DFnDa9P.jpeg)",
    },
    bannerContent: {
        height: 400,
        display: "flex",
        flexDirection: "column",
        paddingTop: 25,
        justifyContent: "space-around",
    },
    tagline: {
        display: "flex",
        height: "40%",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
      },
    carousel: {
        height: "50%",
        display: "flex",
        alignItems: "center",
      },
}))

const Banner = () => {
    const classes = useStyles();

    return (
    <div className={classes.banner}>
<Container className={classes.bannerContent}>
        <div className={classes.tagline}>
          <Typography
            variant="h2"
            style={{
              fontWeight: "bold",
              marginBottom: 15,
              fontFamily: "Montserrat",
            }}
          >
            CryptoGeek
          </Typography>
          <Typography
            variant="subtitle2"
            style={{
              color: "darkgrey",
              textTransform: "capitalize",
              fontFamily: "Montserrat",
            }}
          >
               Get all the information about your favourite cryptocurrency.
         
          </Typography>
        </div>
        <Carousel/>
      </Container>
    </div>
  )
}

export default Banner